export function objToActivationRows(obj) {
    return { activationFrom: obj.activationFrom, activationTo: obj.activationTo, isActive: obj.isActive };
}
